// Wait for Swiper to be loaded before initializing
function initSwipers() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initSwipers, 50);
    return;
  }
  var swiper1 = new Swiper("#first-swiper", {
    spaceBetween: 22,
    grabCursor: true,
    a11y: false,
    freeMode: true,
    speed: 11000,
    loop: true,
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    watchSlidesVisibility: false,
    observer: false,
    observeParents: false,
    resizeObserver: false,
    loopPreventsSliding: false,
    autoplay: {
      delay: 0.5,
      disableOnInteraction: false
    }
  });
  var swiper2 = new Swiper("#second-swiper", {
    spaceBetween: 22,
    grabCursor: true,
    a11y: false,
    freeMode: true,
    speed: 11000,
    loop: true,
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    watchSlidesVisibility: false,
    observer: false,
    observeParents: false,
    resizeObserver: false,
    loopPreventsSliding: false,
    autoplay: {
      delay: 0.5,
      reverseDirection: true,
      disableOnInteraction: false
    }
  });
}

// Start initialization
initSwipers();